import TYPES from '@/modules/shared/types';

// Domain
import {
  InvestmentProductFundTypeRepository,
} from '../../domain/repositories/investment-product-fund-type-repository';
import {
  InvestmentProductFundTypeEntity,
} from '../../domain/entities/investment-product-fund-type-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class InvestmentProductFundTypeHttpRepository implements
  InvestmentProductFundTypeRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/allianz/investment-product-fund-type/`;

  search_available(): Promise<Array<InvestmentProductFundTypeEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(`${this.endpoint}available-by-customer/`)
        .then((response) => {
          response.json()
            .then(({ success, data, error }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(error));
              }
            });
        })
        .catch(reject);
    });
  }
}
